import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Radar from "@/pages/Radar";
import RadarDetail from "@/pages/RadarDetail";
import Copilot from "@/pages/Copilot";
import Sito from "@/pages/Sito";
import Clienti from "@/pages/Clienti";
import Prodotti from "@/pages/Prodotti";
import ChangeImpact from "@/pages/ChangeImpact";
import Documents from "@/pages/Documents";
import Tasks from "@/pages/Tasks";
import Calendario from "@/pages/Calendario";
import Sources from "@/pages/Sources";
import Audit from "@/pages/Audit";
import Inspection from "@/pages/Inspection";
import Readiness from "@/pages/Readiness";
import Reports from "@/pages/Reports";
import Watchlist from "@/pages/Watchlist";
import ComingSoon from "@/pages/ComingSoon";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--ri-bg)]">
        <div className="animate-spin h-8 w-8 border-2 border-blue-600 border-t-transparent rounded-full" />
      </div>
    );
  }
  if (!user && !location.state?.user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/app/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/app/radar" element={<Protected><Radar /></Protected>} />
      <Route path="/app/radar/:id" element={<Protected><RadarDetail /></Protected>} />
      <Route path="/app/copilot" element={<Protected><Copilot /></Protected>} />
      <Route path="/app/sito" element={<Protected><Sito /></Protected>} />
      <Route path="/app/prodotti" element={<Protected><Prodotti /></Protected>} />
      <Route path="/app/clienti" element={<Protected><Clienti /></Protected>} />
      <Route path="/app/change-impact" element={<Protected><ChangeImpact /></Protected>} />
      <Route path="/app/documents" element={<Protected><Documents /></Protected>} />
      <Route path="/app/tasks" element={<Protected><Tasks /></Protected>} />
      <Route path="/app/calendar" element={<Protected><Calendario /></Protected>} />
      <Route path="/app/sources" element={<Protected><Sources /></Protected>} />
      <Route path="/app/audit" element={<Protected><Audit /></Protected>} />
      <Route path="/app/inspection" element={<Protected><Inspection /></Protected>} />
      <Route path="/app/readiness" element={<Protected><Readiness /></Protected>} />
      <Route path="/app/watchlist" element={<Protected><Watchlist /></Protected>} />
      <Route path="/app/reports" element={<Protected><Reports /></Protected>} />
      <Route path="/app/supplier" element={<Protected><ComingSoon title="Supplier Intelligence" /></Protected>} />
      <Route path="/app/commitments" element={<Protected><ComingSoon title="Regulatory Commitments" /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
